import { render } from "./nosto-facet-value.vue?vue&type=template&id=074102e2"
import script from "./nosto-facet-value.vue?vue&type=script&lang=js"
export * from "./nosto-facet-value.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__